import { SVGMap } from "utils/icons";

export type getIconFromLocalOrRemoteOriginParams = {
    iconURL: string;
    iconSize?: { width: string; height: string };
    localIconList?: SVGMap;
    fallback?: JSX.Element;
};

export const getIconFromLocalOrRemoteOrigin = ({
    iconURL,
    localIconList = {},
    iconSize = { width: "auto", height: "auto" },
    fallback = <></>,
}: getIconFromLocalOrRemoteOriginParams) => {
    if (iconURL?.includes("https")) {
        return (
            <img
                width={iconSize.width}
                height={iconSize.height}
                className={"c-application-group__logo-image"}
                style={{ objectFit: "cover" }}
                src={iconURL}
            />
        );
    }

    return localIconList[iconURL] ? localIconList[iconURL]() : fallback;
};
